interface ToolCardProps {
  icon: string;
  title: string;
  description: string;
  badge?: string | null;
  path?: string;
}

export default function ToolCard({ icon, title, description, badge, path }: ToolCardProps) {
  const handleClick = () => {
    if (path && window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE(path);
    }
  };

  return (
    <div 
      onClick={handleClick}
      className="bg-[#1a1a1a] rounded-xl p-6 hover:bg-[#252525] transition-all border border-gray-800 hover:border-gray-700 cursor-pointer"
    >
      <div className="flex items-start gap-4">
        <div className="w-16 h-16 flex items-center justify-center flex-shrink-0">
          <img src={icon} alt={title} className="w-full h-full object-cover rounded-lg" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-2">
            <h3 className="text-base font-semibold text-white">{title}</h3>
            {badge && (
              <span className="px-2 py-0.5 bg-blue-600/20 text-blue-400 text-xs rounded-full whitespace-nowrap">
                {badge}
              </span>
            )}
          </div>
          <p className="text-sm text-gray-400 leading-relaxed">{description}</p>
        </div>
      </div>
    </div>
  );
}
